import type { AccountPaymentMethodAddRequest } from '@cocoonspace/sdk-js/types/accountPaymentMethodAddRequest'
import type { StripeCardElement } from '@stripe/stripe-js'
import { useAddAccountPaymentMethod } from '@cocoonspace/sdk-js/domains/account/account'
import { useMutation } from '@tanstack/react-query'

import { usePayment } from '~/domains/payments/providers/payment.provider'

export type PaymentCreatePayload = {
	card: StripeCardElement
	name: string
	title: string
} & AccountPaymentMethodAddRequest

export const useCreatePaymentMethod = () => {
	const addPaymentMethodMutation = useAddAccountPaymentMethod()
	const { createPaymentMethod } = usePayment()

	return useMutation({
		mutationFn: async ({ card, name, title, type }: PaymentCreatePayload) => {
			const res = await addPaymentMethodMutation.mutateAsync({ data: { type } })

			if (res?.data?.continuation_key) {
				return createPaymentMethod(res.data.continuation_key, {
					billingDetails: { name },
					cardElement: card,
					metadata: { title },
				})
			}
		},
	})
}
